export default __webpack_public_path__ + "static/media/two.b4c9f49a.jpg";